var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterprise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "buildings"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3333 22H5.33325C3.33325 22 2.33325 21 2.33325 19V11C2.33325 9 3.33325 8 5.33325 8H10.3333V19C10.3333 21 11.3333 22 13.3333 22Z",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.4432 4C10.3632 4.3 10.3333 4.63 10.3333 5V8H5.33325V6C5.33325 4.9 6.23325 4 7.33325 4H10.4432Z",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.3333 8V13",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.3333 8V13",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.3333 17H15.3333C14.7833 17 14.3333 17.45 14.3333 18V22H18.3333V18C18.3333 17.45 17.8833 17 17.3333 17Z",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.33325 13V17",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M10.3333 19V5C10.3333 3 11.3333 2 13.3333 2H19.3333C21.3333 2 22.3333 3 22.3333 5V19C22.3333 21 21.3333 22 19.3333 22H13.3333C11.3333 22 10.3333 21 10.3333 19Z",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterprise);
export default __webpack_public_path__ + "static/media/Enterprise.10d1232a1e18229415bf76a9656988cd.svg";
export { ForwardRef as ReactComponent };